import styles from './AnimatedBlueBackdrop.module.css';

export function AnimatedBlueBackdrop() {
  return (
    <>
      <div className={styles.backdrop} aria-hidden="true" />
      <div className={styles.glow} aria-hidden="true" />
    </>
  );
}
